export * from './src/members-v1-santa-member-santa-member.meta.js';
